<template>
  <div class="card-item">
    <div class="card-item-image">
      <img :src="value.card_pic">
    </div>
    <div class="card-item-content">
      <div class="card-name">{{ value.name }}</div>
      <div class="flex-box">
        <div class="flex-item">
          <div>兑换时间: {{ value.create_time }}</div>
          <!-- <div v-if="value.state === 1">有效期: {{ expirationDate.text }}</div>
          <div v-else>使用时间: {{ value.use_time }}</div> -->
          <div>{{ expirationDate.text }}</div>
        </div>
        
        <!-- <van-button
          :disabled="value.state === 3"
          class="check-btn"
          color="#F5DCAD"
          @click="toDetail"
        > {{ btnText }}</van-button> -->
      </div>
    </div>
     <div>
          <slot name="right"></slot>
        </div>
  </div>
</template>
<script>
import { Button } from 'vant';

export default {
  components: {
    [Button.name]: Button
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    expirationDate () {
      const { 'state': dateState, use_time } = this.value
      const date = new Date(this.value.exp_time)
      
      const now = new Date()
      const startYear = date.getFullYear();
      const currentYear = now.getFullYear();
      const expMonth = date.getMonth() + 1
      const nowMonth = now.getMonth() + 1
      // 剩余多少个月
      // 剩余页面多少月
      
      const surplus = (startYear - currentYear) * 12 + (expMonth - nowMonth)
      const timeDiff =  date.getTime() - now.getTime();
      const surplusDay = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
      // const surplusDay = (startYear - ) expDay - nowDay
      let expInfo= {
        months: surplus,
        day: surplusDay,
        text: ''
      }
      console.log(expInfo, 'expInfo');
      
      // if (dateState === 1) {
        if (surplus > 0) {
          expInfo.text = `有效期: ${surplus}个月`
        } else if (surplus === 0 && surplusDay > 0) { 
          expInfo.text = '剩余不足一个月'
        } else {
          expInfo.text = '已过期'
        }
      // } else if (dateState === 2) {
      //   expInfo.text = `使用时间: ${use_time}`
      // } else if (dateState === 3) {
      //   expInfo.text = '已过期'
      // }
      
      return expInfo
    },
    btnText () {
      const { 'state': dateState, card_type } = this.value
      if (dateState === 3) return '已过期'
      if (card_type === 7) return '去使用'

      return '查看'
    }
  },
  methods: {
    toDetail () {
      // 判断是否过期
      if (this.value.state === 3) {
        this.$toast('该优惠券已过期')
        return
      }
      // 如果是商品券，直接跳转商品详情
      if (Number(this.value.card_type) === 7) {
        window.location.href = this.value.extra.url
         return
      }
      // 如果是优惠券，跳转优惠券详情
      this.$router.push({
        path: '/coupon-detail',
        query: {
          c_id: this.value.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .card-item{
    font-size: 0.24rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.1rem;
    background: #f1f1f1;
    border-radius: 5px;
    margin-bottom: 10px;
    width: 6.68rem;
    margin: 0.1rem auto;
    border: 2px solid #F5DCAD;
  }
  .card-item-image{
   width: 1.2rem;
   height: 1.2rem;
   border-radius: 5px;
  }
  .card-item-image img {
    border-radius: 5px;
  }

  .card-item-content{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    height: 1.2rem;
  }

  .flex-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-item{
    color: #999999;

  }

  .check-btn{
    width: 1rem;
    height: 0.58rem;
    color: #000 !important;
    padding: 0;
  }

  .card-name{
    font-size: 0.28rem ;
    font-weight: 800;
    width: 5.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

</style>